import isChunkErrorMessage from './isChunkErrorMessage';

const onRuntimeError = (error: Error, __: string) => {
  if (isChunkErrorMessage(error.message)) {
    window.location.reload();
  }
};

export default onRuntimeError;
